/**
 *  * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'DriverAuditOther',
    path: '/driver-audit/other',
    component: () =>
      import(
        /* webpackChunkName: "DriverAuditOther" */ '@/views/driver-audit/other-info/index'
      ),
    meta: { title: '其他信息' },
  },
  {
    name: 'DriverAuditOtherSubmit',
    path: '/driver-audit/submit',
    component: () =>
      import(
        /* webpackChunkName: "DriverAuditOtherSubmit" */ '@/views/driver-audit/other-info/submit'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'vehicleAudit',
    path: '/vehicle-audit',
    component: () =>
      import(
        /* webpackChunkName: "vehicleAudit" */ '@/views/driver-audit/vehicle-info/index'
      ),
    meta: { title: '车辆信息' },
  },
  {
    name: 'addCarAudit',
    path: '/personal-data/add-car-aduit',
    component: () =>
      import(
        /* webpackChunkName: "vehicleAudit" */ '@/views/personal-data/add-car/add-car-audit'
      ),
    meta: { title: '新增车辆' },
  },
  {
    name: 'vehicleAuditInfo',
    path: '/vehicle-audit/info',
    component: () =>
      import(
        /* webpackChunkName: "vehicleAuditInfo" */ '@/views/driver-audit/vehicle-info/vehicle-info.vue'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'vehicleAuditInfoSubmit',
    path: '/vehicle-audit/submit',
    component: () =>
      import(
        /* webpackChunkName: "vehicleAuditInfoSubmit" */ '@/views/driver-audit/vehicle-info/vehicle-submit.vue'
      ),
    meta: { title: '辅助资料' },
  },
  {
    name: 'SupplementAudit',
    path: '/personal-data/supplement-audit',
    component: () =>
      import(
        /* webpackChunkName: "Supplement" */ '@/views/personal-data/supplement/supplement-audit'
      ),
    meta: { title: '补充资料' },
  },
];
